

































































































import { Mixins, Component, Watch } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { IRollOption } from "../../../../../../../documaker/domain/format/objects";
import { RollOptionSelector } from "../selectors";

@Component({
  components: {
    RollOptionSelector,
  }
})
export default class RollOptionEditDialog extends Mixins(DialogMixin) {
  options: IRollOption[] = [];
  selectedOptions: IRollOption[] = [];

  shouldUnselectedFirst: boolean = false;
  optionText: string = "";
  optionForegroundColor: string = "#000000";
  isOptionBackgroundColorEnable: boolean = false;
  optionBackgroundColor: string = "#ffffff";
  optionScore: number = null;

  confirmed: boolean = false;

  get hasOptionText(): boolean {
    return !!this.optionText;
  }

  get hasSelectedOptions(): boolean {
    return this.selectedOptions.length > 0;
  }

  get hasSingleSelectedOption(): boolean {
    return this.selectedOptions.length === 1;
  }

  get isTopSelectedOption(): boolean {
    return this.hasSelectedOptions && this.selectedOptions.some(v => v === this.options[0]);
  }

  get isBottomSelectedOption(): boolean {
    return this.hasSelectedOptions && this.selectedOptions.some(v => v === this.options[this.options.length - 1]);
  }

  @Watch("optionScore")
  onOptionScoreUpdated(newValue: number, oldValue: number): void {
    if (newValue === oldValue) {
      return;
    }
    if (isNaN(newValue)) {
      this.optionScore = oldValue;
    }
  }

  async show(options: IRollOption[]): Promise<IRollOption[]> {
    return this.showModal(async () => {
      this.options = ObjectUtility.copyDeeply(options.filter(v => !v.isSelected));
      this.selectedOptions = [];

      this.shouldUnselectedFirst = this.options.length !== options.length;
      this.optionText = "";
      this.optionForegroundColor = "#000000";
      this.isOptionBackgroundColorEnable = false;
      this.optionBackgroundColor = "#ffffff";
      this.optionScore = null;

      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed
        ? this.shouldUnselectedFirst
          ? [this.createUnselectedFirstRollOption()].concat(this.options)
          : this.options
        : null;
    });
  }

  private createUnselectedFirstRollOption(): IRollOption {
    return {
      text: "",
      isSelected: true,
      score: null,
      style: {
        foreground: {
          color: {
            value: "#000000",
          }
        },
        background: {
          isEnable: false,
          color: {
            value: "#ffffff",
          }
        },
      },
    };
  }

  changeForegroundColor(value: string) {
    if (value === null) {
      this.optionForegroundColor = "#000000";
    }
  }

  addOption() {
    this.options = this.options.concat({
      text: this.optionText,
      isSelected: false,
      score: this.optionScore,
      style: {
        foreground: {
          color: {
            value: this.optionForegroundColor,
          }
        },
        background: {
          isEnable: this.isOptionBackgroundColorEnable,
          color: {
            value: this.optionBackgroundColor,
          }
        },
      },
    });
  }

  updateOption() {
    this.selectedOptions[0].text = this.optionText;
    this.selectedOptions[0].style.foreground.color.value = this.optionForegroundColor;
    this.selectedOptions[0].style.background.isEnable = this.isOptionBackgroundColorEnable;
    this.selectedOptions[0].style.background.color.value = this.optionBackgroundColor;
    this.selectedOptions[0].score = this.optionScore;
  }

  moveOptions(offset: number) {
    const indexes = this.selectedOptions.map(v => this.options.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.options[index];
    this.options.splice(index, 1);
    this.options.splice(index + offset, 0, item);
  }

  removeOptions() {
    this.options = this.options.filter((v) => !this.selectedOptions.some(s => s === v));
  }

  changeOptions(value: IRollOption[]) {
    this.selectedOptions = value;
    if (value.length === 1) {
      const option = ObjectUtility.copyDeeply(value[0]) as IRollOption;
      this.optionText = option.text;
      this.optionForegroundColor = option.style.foreground.color.value;
      this.isOptionBackgroundColorEnable = option.style.background.isEnable;
      this.optionBackgroundColor = option.style.background.color.value;
      this.optionScore = option.score;
    }
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
